import { useOrdersUiStore } from '../../portals/orders/ordersUiStore';
import { useProjectsUiStore } from '../../portals/projects/projectsUiStore';
import { requestOpenLens } from '../../portals/data/lensBank/lensOpenBridge';
import { requestOpenLtd } from '../../portals/data/lensBank/lensDev/lensDevOpenBridge';
import { prepareHomeOrdersAddress } from '../home/model/homeOrdersAddress';

export const recordPortal = {item:'catalog',brand:'catalog',dev:'developments',designer:'developments',lens:'lens',ltd:'lens',order:'orders',acetate:'acetate'};
export function navigateSearchRecord(sel, {ui,setSelected,setFBrand}) {
  ui.setShowGlobalSearch(false); ui.setGlobalSearch('');
  if (sel.tab === 'projects' && !sel.projectsView && ['portal', 'page'].includes(sel.k)) {
    useProjectsUiStore.getState().openChooser(); return;
  }
  ui.setEntryPhase('app');
  if (sel.k === 'item') { ui.setTab('catalog'); setSelected(sel); }
  if (sel.k === 'dev') { ui.setTab('developments'); setTimeout(() => window.dispatchEvent(new CustomEvent('open_dev_panel', {detail:{id:sel.id}})),100); }
  if (sel.k === 'designer') { ui.setTab('developments'); ui.setDevView('board'); ui.setDevFilters(prev=>({...prev,designer:new Set([sel.name])})); }
  if (sel.k === 'brand') { setFBrand(new Set([sel.name])); ui.setTab('catalog'); }
  if (sel.k === 'portal' || sel.k === 'page') {
    ui.setTab(sel.tab);
    if(sel.devView)ui.setDevView(sel.devView);
    if(sel.salesView)ui.setSalesView(sel.salesView);
    if(sel.projectsView)useProjectsUiStore.getState().setProjectsView(sel.projectsView);
  }
  if(sel.k==='lens'){ui.setTab('lensBank');requestOpenLens(sel.lens_no);}
  if(sel.k==='ltd'){ui.setTab('lensBank');requestOpenLtd(sel.code);}
  if(sel.k==='order'){
    const desk=sel.source==='desk';
    prepareHomeOrdersAddress({world:desk?'desk':'book',deskView:'card',ordersView:'data'});
    const url=new URL(window.location.href);url.searchParams.set(desk?'id':'line',sel.id);
    window.history.replaceState({},'',url);
    const orders=useOrdersUiStore.getState();
    if(desk)orders.openDeskOrder(sel.id);else orders.openLine(sel.id);
    ui.setTab('orders');
  }
  if(sel.k==='acetate'){
    const url=new URL(window.location.href);url.searchParams.set('acetate',sel.acetate_no);url.searchParams.delete('acetate_view');
    window.history.replaceState({},'',url);ui.setTab('acetateBank');
  }
}
